import { Button } from "antd";
import React, { useCallback, useEffect } from "react";
import { useCreateRole } from "../../../entities/api";

export const SubmitCandidateButton = ({ entityId, seasonId, person, role, setIsLoadingForPerson, status, refetch }) => {
  const { mutateAsync: createFn, isPending: isCreatePending } = useCreateRole();

  useEffect(() => {
    setIsLoadingForPerson(isCreatePending);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreatePending]);

  const submitCandidate = useCallback(async () => {
    await createFn({
      personId: person.personId,
      role: role,
      seasonId,
      entityId,
      status: status,
    });
    await refetch();
  }, [createFn, entityId, person.personId, role, seasonId, status, refetch]);

  return (
    <Button onClick={submitCandidate} loading={isCreatePending} icon={<i className="fas fa-plus" />} size="small" />
  );
};
